import React from 'react'

import MainContentSubAccessories from '../MainContentSubAccessories'

const ProtectorBagSub = () => {
  return (
    <div className='pageAccessories bg-accessories-sub-page'>
        <MainContentSubAccessories parentCate={'Phụ kiện laptop'}  
            childCate={'Balo, Túi chống sốc'} 
            // listProduct={listProductSub}
    />
</div>
  )
}

export default ProtectorBagSub
